module.exports = __webpack_public_path__ + "static/media/floral-ornament-of-spirals-svgrepo-com.731a7a78.svg";